import type { TextFieldProps } from 'react-aria-components';

export const newInvestmentFormFieldsInfo = [
  { fieldType: 'select', id: 'countries', isRequired: true },
  { fieldType: 'input', id: 'firstName', isRequired: true },
  { fieldType: 'input', id: 'lastName', isRequired: true },
  { fieldType: 'input', id: 'centerName', isRequired: false },
  {
    fieldType: 'input',
    id: 'contactAddress',
    isRequired: true,
  },
  {
    fieldType: 'input',
    id: 'contactAddress2',
    isRequired: false,
  },
  {
    fieldType: 'input',
    id: 'city',
    isRequired: true,
  },
  {
    fieldType: 'input',
    id: 'zipcode',
    isRequired: true,
  },
  {
    fieldType: 'input',
    id: 'phone',
    isRequired: true,
  },
  {
    fieldType: 'input',
    id: 'phone2',
    isRequired: true,
  },
  {
    fieldType: 'input',
    id: 'email',
    isRequired: true,
  },
  {
    fieldType: 'input',
    id: 'occupation',
    isRequired: true,
  },
];

export const newInvestmentFormLocationInfo = [
  { fieldType: 'boolean', id: 'location', isRequired: true },
  { fieldType: 'boolean', id: 'land', isRequired: true },
  { fieldType: 'boolean', id: 'new_building', isRequired: true },
  { fieldType: 'boolean', id: 'building', isRequired: true },
  {
    fieldType: 'select',
    id: 'new-investment-business-model-location',
    isRequired: true,
  },
];

export const newInvestmentBusinessInfo = [
  {
    fieldType: 'select',
    id: 'new-investment-type-of-product',
    isRequired: true,
  },
  { fieldType: 'boolean', id: 'demographic_analysis', isRequired: true },
  { fieldType: 'boolean', id: 'market_feasibility_study', isRequired: true },
  { fieldType: 'boolean', id: 'cash_flow_projection', isRequired: true },
  { fieldType: 'boolean', id: 'equity_availability', isRequired: true },
  { fieldType: 'boolean', id: 'investors', isRequired: false },
  { fieldType: 'textarea', id: 'about_project', isRequired: false },
];

export const generalInquiriesFieldsInfo = ({
  jobTitleOptions,
  handleArrayChange,
  arrayValue,
}) => {
  return [
    { fieldType: 'select', id: 'countries', isRequired: true },
    { fieldType: 'input', id: 'firstName', isRequired: true },
    { fieldType: 'input', id: 'lastName', isRequired: true },
    { fieldType: 'input', id: 'centerName', isRequired: false },
    {
      fieldType: 'input',
      id: 'lanesNumber',
      isRequired: false,
      type: 'numeric' as TextFieldProps['inputMode'],
    },
    {
      fieldType: 'input',
      id: 'contactAddress',
      isRequired: true,
    },
    {
      fieldType: 'input',
      id: 'city',
      isRequired: true,
    },
    {
      fieldType: 'input',
      id: 'zipcode',
      isRequired: true,
    },
    {
      fieldType: 'input',
      id: 'phone',
      isRequired: true,
    },
    {
      fieldType: 'input',
      id: 'email',
      isRequired: true,
    },
    {
      fieldType: 'select',
      id: 'jobTitle',
      options: jobTitleOptions,
      isRequired: true,
    },
    {
      fieldType: 'arrayWidget',
      onChange: handleArrayChange,
      values: arrayValue,
      id: 'products',
      isRequired: false,
    },
    {
      fieldType: 'textarea',
      id: 'notes',
      isRequired: false,
    },
  ];
};
